const stripSupplierCode = (formData) => {
    const { code, ...rest } = formData;
    return rest;
};

export const buildVendorUpdatePayload = (formData, username) => ({
    ...stripSupplierCode(formData),
    edit_by: username || ''
});

export const buildVendorCreatePayload = (formData, username) => ({
    ...stripSupplierCode(formData),
    input_by: username || ''
});
